import KioskLog from 'models/KioskLog';
import React from 'react';
import ProductContainer from 'features/Product';
import { useParams } from "react-router-dom";
import withRouter from '../../shared/utils/WithRouter'

// need to convert product id back to number
const ProductPage = (props) => {
	const { id } = useParams();
	const state = props.router.location.state

	if (Number.isInteger(Number(id)) && state !== undefined) {
		return (
			<ProductContainer
				id={parseInt(id, 10)}
				sku={state.sku}
				categoryId={state.categoryId}
			/>
		);
	}
	const log = new KioskLog(
		new Error('Product not located.'),
		`id: ${id} - fileLocation: pages/ProductPage`,
	);
	log.postMessage();
	props.router.navigate('/errorPage', { 
		state: { 
			text: `We don't think the product ID "${id}" exists.` 
		} 
	});
	return null;
};

export default withRouter(ProductPage);
